import { html } from "htm/preact";
import { useEffect } from "preact/hooks";

export default function ButtonTop() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const btn = document.getElementById("button-top");
    const target = document.querySelector("#header");

    if (!btn || !target) return;

    // Create observer to change opacity on button
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        btn.classList.remove("opacity-0");
        btn.classList.remove("pointer-events-none");
        btn.classList.add("opacity-100");
      } else {

        btn.classList.add("opacity-0");
        btn.classList.add("pointer-events-none");
        btn.classList.remove("opacity-100");
      }
    })

    // Initialize the observer
    observer.observe(target);

    return () => observer.disconnect();
  }, []);

}
